<script setup lang="ts">
const systemStore = useSystemStore()
</script>

<template>
  <v-dialog v-model="systemStore.loading" persistent style="z-index: 9999">
    <v-progress-circular size="80" width="5" color="c1" indeterminate class="mx-auto">
      <v-progress-circular size="60" width="7" color="c2" indeterminate rotate="90">
        <v-progress-circular size="40" width="5" color="fieldBG" indeterminate rotate="180" />
      </v-progress-circular>
    </v-progress-circular>
    <v-label class="font-weight-medium text-white mx-auto mt-2 text-center opacity-100">
      {{ systemStore.loadingComment }}
    </v-label>
  </v-dialog>
</template>
